import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const Text = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.text)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.text)}
`;
